import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgLinkedin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M23 5a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4zM7.527 19.747H4.26V9.246h3.266zM5.894 7.815a1.892 1.892 0 1 1-.007-3.783 1.892 1.892 0 0 1 .007 3.783m13.853 11.932h-3.261v-5.104c0-1.216-.021-2.785-1.697-2.785-1.698 0-1.955 1.328-1.955 2.699v5.19H9.577V9.246h3.128v1.435h.043c.434-.825 1.5-1.697 3.085-1.697 3.304 0 3.914 2.174 3.914 5.001z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgLinkedin)
export default ForwardRef
